"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapCheck = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
const react_1 = require("react");
const de_ui_1 = require("@delab-team/de-ui");
// eslint-disable-next-line import/no-extraneous-dependencies
const react_i18next_1 = require("react-i18next");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const swapcheck_module_css_1 = __importDefault(require("./swapcheck.module.css"));
const money_gif_1 = __importDefault(require("../../../assets/gifs/money.gif"));
const error_gif_1 = __importDefault(require("../../../assets/gifs/error.gif"));
const buttonTgStyles = {
    background: 'var(--tg-theme-button-color)',
    color: 'var(--tg-theme-button-text-color)'
};
const SwapCheck = (props) => {
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleViewIn = () => {
        console.log('SWAP CHECK');
        // window.open(`https://tonviewer.com/${props.addressUser}`, '_blank')
        TgObj.openLink(`https://tonviewer.com/${props.addressUser}`);
    };
    function enableBtn() {
        TgObj.MainButton.enable();
        TgObj.MainButton.show();
        if (props.position === 2) {
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('common.view-in-blockchain');
            TgObj.MainButton.enable();
        }
    }
    (0, react_1.useEffect)(() => {
        if (props.position !== 2)
            return;
        enableBtn();
        const handleBtnClick = handleViewIn;
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [props.position === 2, props.position]);
    function enableBackBtn() {
        TgObj.BackButton.show();
    }
    (0, react_1.useEffect)(() => {
        enableBackBtn();
        TgObj.BackButton.onClick(props.handleCloseModal);
        return () => {
            TgObj.BackButton.offClick(props.handleCloseModal);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: `${swapcheck_module_css_1.default.modalContent}`, children: props.isSwapSuccess ? ((0, jsx_runtime_1.jsxs)("div", { className: `${swapcheck_module_css_1.default.checkContent}`, children: [(0, jsx_runtime_1.jsx)("img", { src: money_gif_1.default, alt: "success" }), (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h4", className: swapcheck_module_css_1.default.modalContentTitle, children: t('swap-modal.swap-success') }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: swapcheck_module_css_1.default.modalContentText, children: t('swap-modal.swap-success2') })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: `${swapcheck_module_css_1.default.checkContent}`, children: [(0, jsx_runtime_1.jsx)("img", { src: error_gif_1.default, alt: "error" }), (0, jsx_runtime_1.jsx)(de_ui_1.Title, { variant: "h3", className: swapcheck_module_css_1.default.modalContentTitle, children: t('swap-modal.swap-failed') }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: swapcheck_module_css_1.default.modalContentText, children: t('swap-modal.swap-failed2') })] })) }) }));
};
exports.SwapCheck = SwapCheck;
